// extracted by mini-css-extract-plugin
module.exports = {"breakDownContainerStyle":"wrjugs_pYSvmr1RGybgfK"};